// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Uuid from "uuid";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Client from "@apollo/client";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as PromotionEditDiscountedProduct from "./PromotionEditDiscountedProduct.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let MakeCreateCampaignsInputs_CreatorIdentifierEmpty = /* @__PURE__ */Primitive_exceptions.create("PromotionEditFormMutations.MakeCreateCampaignsInputs_CreatorIdentifierEmpty");

let MakeCreateCampaignsInputs_NameEmpty = /* @__PURE__ */Primitive_exceptions.create("PromotionEditFormMutations.MakeCreateCampaignsInputs_NameEmpty");

let MakeCreateCampaignsInputs_PeriodNotFound = /* @__PURE__ */Primitive_exceptions.create("PromotionEditFormMutations.MakeCreateCampaignsInputs_PeriodNotFound");

let MakeCreateCampaignsInputs_InvalidDiscountedProduct = /* @__PURE__ */Primitive_exceptions.create("PromotionEditFormMutations.MakeCreateCampaignsInputs_InvalidDiscountedProduct");

let MakeUpdateCampaignsInputs_NameEmpty = /* @__PURE__ */Primitive_exceptions.create("PromotionEditFormMutations.MakeUpdateCampaignsInputs_NameEmpty");

let MakeUpdateCampaignsInputs_PeriodNotFound = /* @__PURE__ */Primitive_exceptions.create("PromotionEditFormMutations.MakeUpdateCampaignsInputs_PeriodNotFound");

let MakeUpdateCampaignsInputs_InvalidDiscountedProduct = /* @__PURE__ */Primitive_exceptions.create("PromotionEditFormMutations.MakeUpdateCampaignsInputs_InvalidDiscountedProduct");

let CreateGlobalCampaignMutation_InvalidInputs = /* @__PURE__ */Primitive_exceptions.create("PromotionEditFormMutations.CreateGlobalCampaignMutation_InvalidInputs");

let CreateGlobalCampaignMutation_CreatorIdentifierNotFound = /* @__PURE__ */Primitive_exceptions.create("PromotionEditFormMutations.CreateGlobalCampaignMutation_CreatorIdentifierNotFound");

let UpdateGlobalCampaignMutation_InvalidInputs = /* @__PURE__ */Primitive_exceptions.create("PromotionEditFormMutations.UpdateGlobalCampaignMutation_InvalidInputs");

let StartCampaignMutation_InvalidStatus = /* @__PURE__ */Primitive_exceptions.create("PromotionEditFormMutations.StartCampaignMutation_InvalidStatus");

let StopCampaignMutation_InvalidStatus = /* @__PURE__ */Primitive_exceptions.create("PromotionEditFormMutations.StopCampaignMutation_InvalidStatus");

let Raw = {};

let query = Client.gql(["mutation createPromotionCampaign($id: ID!, $cku: CKU!, $input: InputCreatePromotionCampaign!, $discountsInput: [InputPromotionCampaignDiscounts!]!)  {\ncreatePromotionCampaign(id: $id, cku: $cku, input: $input, promotionCampaignDiscountsInput: $discountsInput)  {\n__typename  \nid  \ncku  \nformattedStatus  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.createPromotionCampaign;
  let value$2 = value$1.formattedStatus;
  let tmp;
  switch (value$2) {
    case "ARCHIVED" :
      tmp = "ARCHIVED";
      break;
    case "DRAFT" :
      tmp = "DRAFT";
      break;
    case "EXPIRED" :
      tmp = "EXPIRED";
      break;
    case "NOT_PROGRAMMED" :
      tmp = "NOT_PROGRAMMED";
      break;
    case "ONGOING" :
      tmp = "ONGOING";
      break;
    case "PROGRAMMED" :
      tmp = "PROGRAMMED";
      break;
    case "STOPPED" :
      tmp = "STOPPED";
      break;
    default:
      throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
  }
  return {
    createPromotionCampaign: {
      __typename: value$1.__typename,
      id: value$1.id,
      cku: Scalar.CKU.parse(value$1.cku),
      formattedStatus: tmp
    }
  };
}

function serialize(value) {
  let value$1 = value.createPromotionCampaign;
  let value$2 = value$1.formattedStatus;
  let formattedStatus = value$2 === "STOPPED" ? "STOPPED" : (
      value$2 === "ARCHIVED" ? "ARCHIVED" : (
          value$2 === "DRAFT" ? "DRAFT" : (
              value$2 === "NOT_PROGRAMMED" ? "NOT_PROGRAMMED" : (
                  value$2 === "ONGOING" ? "ONGOING" : (
                      value$2 === "EXPIRED" ? "EXPIRED" : "PROGRAMMED"
                    )
                )
            )
        )
    );
  let value$3 = value$1.cku;
  let value$4 = Scalar.CKU.serialize(value$3);
  let value$5 = value$1.id;
  let value$6 = value$1.__typename;
  let createPromotionCampaign = {
    __typename: value$6,
    id: value$5,
    cku: value$4,
    formattedStatus: formattedStatus
  };
  return {
    createPromotionCampaign: createPromotionCampaign
  };
}

function serializeInputObjectInputCreatePromotionCampaign(inp) {
  let a = inp.recurringDays;
  let a$1 = inp.recurringStartTime;
  let a$2 = inp.recurringEndTime;
  return {
    creatorIdentifier: inp.creatorIdentifier,
    name: inp.name,
    startDate: inp.startDate,
    endDate: inp.endDate,
    recurringDays: a !== undefined ? a.map(b => {
        if (b === "SUNDAY") {
          return "SUNDAY";
        } else if (b === "SATURDAY") {
          return "SATURDAY";
        } else if (b === "THURSDAY") {
          return "THURSDAY";
        } else if (b === "FRIDAY") {
          return "FRIDAY";
        } else if (b === "MONDAY") {
          return "MONDAY";
        } else if (b === "TUESDAY") {
          return "TUESDAY";
        } else {
          return "WEDNESDAY";
        }
      }) : undefined,
    recurringStartTime: a$1 !== undefined ? a$1 : undefined,
    recurringEndTime: a$2 !== undefined ? a$2 : undefined,
    priceId: inp.priceId,
    shopId: inp.shopId
  };
}

function serializeInputObjectInputPromotionCampaignDiscounts(inp) {
  let a = inp.kind;
  return {
    variantCku: inp.variantCku,
    value: inp.value,
    kind: a === "PERCENT" ? "PERCENT" : "CURRENCY"
  };
}

function serializeVariables(inp) {
  let a = inp.discountsInput;
  return {
    id: inp.id,
    cku: inp.cku,
    input: serializeInputObjectInputCreatePromotionCampaign(inp.input),
    discountsInput: a.map(serializeInputObjectInputPromotionCampaignDiscounts)
  };
}

function makeVariables(id, cku, input, discountsInput, param) {
  return {
    id: id,
    cku: cku,
    input: input,
    discountsInput: discountsInput
  };
}

function makeInputObjectInputCreatePromotionCampaign(creatorIdentifier, name, startDate, endDate, recurringDays, recurringStartTime, recurringEndTime, priceId, shopId, param) {
  return {
    creatorIdentifier: creatorIdentifier,
    name: name,
    startDate: startDate,
    endDate: endDate,
    recurringDays: recurringDays,
    recurringStartTime: recurringStartTime,
    recurringEndTime: recurringEndTime,
    priceId: priceId,
    shopId: shopId
  };
}

function makeInputObjectInputPromotionCampaignDiscounts(variantCku, value, kind, param) {
  return {
    variantCku: variantCku,
    value: value,
    kind: kind
  };
}

let CreateCampaignMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreatePromotionCampaign: serializeInputObjectInputCreatePromotionCampaign,
  serializeInputObjectInputPromotionCampaignDiscounts: serializeInputObjectInputPromotionCampaignDiscounts,
  makeVariables: makeVariables,
  makeInputObjectInputCreatePromotionCampaign: makeInputObjectInputCreatePromotionCampaign,
  makeInputObjectInputPromotionCampaignDiscounts: makeInputObjectInputPromotionCampaignDiscounts
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let CreateCampaignMutation_useWithVariables = include.useWithVariables;

let CreateCampaignMutation = {
  CreateCampaignMutation_inner: CreateCampaignMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreatePromotionCampaign: serializeInputObjectInputCreatePromotionCampaign,
  serializeInputObjectInputPromotionCampaignDiscounts: serializeInputObjectInputPromotionCampaignDiscounts,
  makeVariables: makeVariables,
  makeInputObjectInputCreatePromotionCampaign: makeInputObjectInputCreatePromotionCampaign,
  makeInputObjectInputPromotionCampaignDiscounts: makeInputObjectInputPromotionCampaignDiscounts,
  use: use,
  useWithVariables: CreateCampaignMutation_useWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["mutation updatePromotionCampaign($id: ID!, $input: InputUpdatePromotionCampaign!, $discountsInput: [InputPromotionCampaignDiscounts!]!)  {\nupdatePromotionCampaign(id: $id, input: $input, promotionCampaignDiscountsInput: $discountsInput)  {\n__typename  \nid  \ncku  \nname  \nstartDate  \nendDate  \nformattedStatus  \n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.updatePromotionCampaign;
  let value$2 = value$1.formattedStatus;
  let tmp;
  switch (value$2) {
    case "ARCHIVED" :
      tmp = "ARCHIVED";
      break;
    case "DRAFT" :
      tmp = "DRAFT";
      break;
    case "EXPIRED" :
      tmp = "EXPIRED";
      break;
    case "NOT_PROGRAMMED" :
      tmp = "NOT_PROGRAMMED";
      break;
    case "ONGOING" :
      tmp = "ONGOING";
      break;
    case "PROGRAMMED" :
      tmp = "PROGRAMMED";
      break;
    case "STOPPED" :
      tmp = "STOPPED";
      break;
    default:
      throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
  }
  return {
    updatePromotionCampaign: {
      __typename: value$1.__typename,
      id: value$1.id,
      cku: Scalar.CKU.parse(value$1.cku),
      name: value$1.name,
      startDate: Scalar.Datetime.parse(value$1.startDate),
      endDate: Scalar.Datetime.parse(value$1.endDate),
      formattedStatus: tmp
    }
  };
}

function serialize$1(value) {
  let value$1 = value.updatePromotionCampaign;
  let value$2 = value$1.formattedStatus;
  let formattedStatus = value$2 === "STOPPED" ? "STOPPED" : (
      value$2 === "ARCHIVED" ? "ARCHIVED" : (
          value$2 === "DRAFT" ? "DRAFT" : (
              value$2 === "NOT_PROGRAMMED" ? "NOT_PROGRAMMED" : (
                  value$2 === "ONGOING" ? "ONGOING" : (
                      value$2 === "EXPIRED" ? "EXPIRED" : "PROGRAMMED"
                    )
                )
            )
        )
    );
  let value$3 = value$1.endDate;
  let value$4 = Scalar.Datetime.serialize(value$3);
  let value$5 = value$1.startDate;
  let value$6 = Scalar.Datetime.serialize(value$5);
  let value$7 = value$1.name;
  let value$8 = value$1.cku;
  let value$9 = Scalar.CKU.serialize(value$8);
  let value$10 = value$1.id;
  let value$11 = value$1.__typename;
  let updatePromotionCampaign = {
    __typename: value$11,
    id: value$10,
    cku: value$9,
    name: value$7,
    startDate: value$6,
    endDate: value$4,
    formattedStatus: formattedStatus
  };
  return {
    updatePromotionCampaign: updatePromotionCampaign
  };
}

function serializeInputObjectInputPromotionCampaignDiscounts$1(inp) {
  let a = inp.kind;
  return {
    variantCku: inp.variantCku,
    value: inp.value,
    kind: a === "PERCENT" ? "PERCENT" : "CURRENCY"
  };
}

function serializeInputObjectInputUpdatePromotionCampaign(inp) {
  let a = inp.name;
  let a$1 = inp.startDate;
  let a$2 = inp.endDate;
  let a$3 = inp.recurringDays;
  let a$4 = inp.recurringStartTime;
  let a$5 = inp.recurringEndTime;
  return {
    name: a !== undefined ? a : undefined,
    startDate: a$1 !== undefined ? a$1 : undefined,
    endDate: a$2 !== undefined ? a$2 : undefined,
    recurringDays: a$3 !== undefined ? a$3.map(b => {
        if (b === "SUNDAY") {
          return "SUNDAY";
        } else if (b === "SATURDAY") {
          return "SATURDAY";
        } else if (b === "THURSDAY") {
          return "THURSDAY";
        } else if (b === "FRIDAY") {
          return "FRIDAY";
        } else if (b === "MONDAY") {
          return "MONDAY";
        } else if (b === "TUESDAY") {
          return "TUESDAY";
        } else {
          return "WEDNESDAY";
        }
      }) : undefined,
    recurringStartTime: a$4 !== undefined ? a$4 : undefined,
    recurringEndTime: a$5 !== undefined ? a$5 : undefined
  };
}

function serializeVariables$1(inp) {
  let a = inp.discountsInput;
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdatePromotionCampaign(inp.input),
    discountsInput: a.map(serializeInputObjectInputPromotionCampaignDiscounts$1)
  };
}

function makeVariables$1(id, input, discountsInput, param) {
  return {
    id: id,
    input: input,
    discountsInput: discountsInput
  };
}

function makeInputObjectInputUpdatePromotionCampaign(name, startDate, endDate, recurringDays, recurringStartTime, recurringEndTime, param) {
  return {
    name: name,
    startDate: startDate,
    endDate: endDate,
    recurringDays: recurringDays,
    recurringStartTime: recurringStartTime,
    recurringEndTime: recurringEndTime
  };
}

function makeInputObjectInputPromotionCampaignDiscounts$1(variantCku, value, kind, param) {
  return {
    variantCku: variantCku,
    value: value,
    kind: kind
  };
}

let UpdateCampaignMutation_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdatePromotionCampaign: serializeInputObjectInputUpdatePromotionCampaign,
  serializeInputObjectInputPromotionCampaignDiscounts: serializeInputObjectInputPromotionCampaignDiscounts$1,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdatePromotionCampaign: makeInputObjectInputUpdatePromotionCampaign,
  makeInputObjectInputPromotionCampaignDiscounts: makeInputObjectInputPromotionCampaignDiscounts$1
};

let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let UpdateCampaignMutation_useWithVariables = include$1.useWithVariables;

let UpdateCampaignMutation = {
  UpdateCampaignMutation_inner: UpdateCampaignMutation_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdatePromotionCampaign: serializeInputObjectInputUpdatePromotionCampaign,
  serializeInputObjectInputPromotionCampaignDiscounts: serializeInputObjectInputPromotionCampaignDiscounts$1,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdatePromotionCampaign: makeInputObjectInputUpdatePromotionCampaign,
  makeInputObjectInputPromotionCampaignDiscounts: makeInputObjectInputPromotionCampaignDiscounts$1,
  use: use$1,
  useWithVariables: UpdateCampaignMutation_useWithVariables
};

let Raw$2 = {};

let query$2 = Client.gql(["mutation startPromotionCampaign($id: ID!)  {\nstartPromotionCampaign(id: $id)  {\n__typename  \nid  \ncku  \nformattedStatus  \n}\n\n}\n"]);

function parse$2(value) {
  let value$1 = value.startPromotionCampaign;
  let value$2 = value$1.formattedStatus;
  let tmp;
  switch (value$2) {
    case "ARCHIVED" :
      tmp = "ARCHIVED";
      break;
    case "DRAFT" :
      tmp = "DRAFT";
      break;
    case "EXPIRED" :
      tmp = "EXPIRED";
      break;
    case "NOT_PROGRAMMED" :
      tmp = "NOT_PROGRAMMED";
      break;
    case "ONGOING" :
      tmp = "ONGOING";
      break;
    case "PROGRAMMED" :
      tmp = "PROGRAMMED";
      break;
    case "STOPPED" :
      tmp = "STOPPED";
      break;
    default:
      throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
  }
  return {
    startPromotionCampaign: {
      __typename: value$1.__typename,
      id: value$1.id,
      cku: Scalar.CKU.parse(value$1.cku),
      formattedStatus: tmp
    }
  };
}

function serialize$2(value) {
  let value$1 = value.startPromotionCampaign;
  let value$2 = value$1.formattedStatus;
  let formattedStatus = value$2 === "STOPPED" ? "STOPPED" : (
      value$2 === "ARCHIVED" ? "ARCHIVED" : (
          value$2 === "DRAFT" ? "DRAFT" : (
              value$2 === "NOT_PROGRAMMED" ? "NOT_PROGRAMMED" : (
                  value$2 === "ONGOING" ? "ONGOING" : (
                      value$2 === "EXPIRED" ? "EXPIRED" : "PROGRAMMED"
                    )
                )
            )
        )
    );
  let value$3 = value$1.cku;
  let value$4 = Scalar.CKU.serialize(value$3);
  let value$5 = value$1.id;
  let value$6 = value$1.__typename;
  let startPromotionCampaign = {
    __typename: value$6,
    id: value$5,
    cku: value$4,
    formattedStatus: formattedStatus
  };
  return {
    startPromotionCampaign: startPromotionCampaign
  };
}

function serializeVariables$2(inp) {
  return {
    id: inp.id
  };
}

function makeVariables$2(id, param) {
  return {
    id: id
  };
}

let StartCampaignMutation_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2
};

let include$2 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2
});

let use$2 = include$2.use;

let StartCampaignMutation_useWithVariables = include$2.useWithVariables;

let StartCampaignMutation = {
  StartCampaignMutation_inner: StartCampaignMutation_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  use: use$2,
  useWithVariables: StartCampaignMutation_useWithVariables
};

let Raw$3 = {};

let query$3 = Client.gql(["mutation stopPromotionCampaign($id: ID!)  {\nstopPromotionCampaign(id: $id)  {\n__typename  \nid  \ncku  \nformattedStatus  \n}\n\n}\n"]);

function parse$3(value) {
  let value$1 = value.stopPromotionCampaign;
  let value$2 = value$1.formattedStatus;
  let tmp;
  switch (value$2) {
    case "ARCHIVED" :
      tmp = "ARCHIVED";
      break;
    case "DRAFT" :
      tmp = "DRAFT";
      break;
    case "EXPIRED" :
      tmp = "EXPIRED";
      break;
    case "NOT_PROGRAMMED" :
      tmp = "NOT_PROGRAMMED";
      break;
    case "ONGOING" :
      tmp = "ONGOING";
      break;
    case "PROGRAMMED" :
      tmp = "PROGRAMMED";
      break;
    case "STOPPED" :
      tmp = "STOPPED";
      break;
    default:
      throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
  }
  return {
    stopPromotionCampaign: {
      __typename: value$1.__typename,
      id: value$1.id,
      cku: Scalar.CKU.parse(value$1.cku),
      formattedStatus: tmp
    }
  };
}

function serialize$3(value) {
  let value$1 = value.stopPromotionCampaign;
  let value$2 = value$1.formattedStatus;
  let formattedStatus = value$2 === "STOPPED" ? "STOPPED" : (
      value$2 === "ARCHIVED" ? "ARCHIVED" : (
          value$2 === "DRAFT" ? "DRAFT" : (
              value$2 === "NOT_PROGRAMMED" ? "NOT_PROGRAMMED" : (
                  value$2 === "ONGOING" ? "ONGOING" : (
                      value$2 === "EXPIRED" ? "EXPIRED" : "PROGRAMMED"
                    )
                )
            )
        )
    );
  let value$3 = value$1.cku;
  let value$4 = Scalar.CKU.serialize(value$3);
  let value$5 = value$1.id;
  let value$6 = value$1.__typename;
  let stopPromotionCampaign = {
    __typename: value$6,
    id: value$5,
    cku: value$4,
    formattedStatus: formattedStatus
  };
  return {
    stopPromotionCampaign: stopPromotionCampaign
  };
}

function serializeVariables$3(inp) {
  return {
    id: inp.id
  };
}

function makeVariables$3(id, param) {
  return {
    id: id
  };
}

let StopCampaignMutation_inner = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3
};

let include$3 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$3,
  Raw: Raw$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3
});

let use$3 = include$3.use;

let StopCampaignMutation_useWithVariables = include$3.useWithVariables;

let StopCampaignMutation = {
  StopCampaignMutation_inner: StopCampaignMutation_inner,
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  use: use$3,
  useWithVariables: StopCampaignMutation_useWithVariables
};

function makeCreateCampaignsInputs(state, creatorIdentifier) {
  let match = state.period;
  let match$1;
  if (match !== undefined) {
    match$1 = [
      Scalar.Datetime.serialize(match[0]),
      Scalar.Datetime.serialize(match[1])
    ];
  } else {
    throw {
      RE_EXN_ID: MakeCreateCampaignsInputs_PeriodNotFound,
      Error: new Error()
    };
  }
  let endDate = match$1[1];
  let startDate = match$1[0];
  let rootCampaignsInputs = Stdlib_Array.filterMap(Belt_Array.reverse(state.rootCampaigns), campaign => {
    let match = state.name;
    if (!campaign.selected) {
      return;
    }
    if (creatorIdentifier === "") {
      throw {
        RE_EXN_ID: MakeCreateCampaignsInputs_CreatorIdentifierEmpty,
        Error: new Error()
      };
    }
    if (match !== "") {
      return [
        campaign.id,
        makeInputObjectInputCreatePromotionCampaign(creatorIdentifier, state.name, startDate, endDate, undefined, undefined, undefined, campaign.priceId, campaign.shopId, undefined)
      ];
    }
    throw {
      RE_EXN_ID: MakeCreateCampaignsInputs_NameEmpty,
      Error: new Error()
    };
  });
  let discountsInput = Belt_Array.reverse(state.discountedProducts).map(product => {
    let match = PromotionEditDiscountedProduct.isValid(product, state.priceName);
    if (match) {
      return {
        variantCku: Scalar.CKU.serialize(product.cku),
        value: product.discount.amount,
        kind: product.discount.kind
      };
    }
    throw {
      RE_EXN_ID: MakeCreateCampaignsInputs_InvalidDiscountedProduct,
      Error: new Error()
    };
  });
  return [
    rootCampaignsInputs,
    discountsInput
  ];
}

function useCreateGlobalCampaign() {
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let result = match[1];
  let mutate = match[0];
  let authState = Auth.useState();
  return React.useCallback((param, state) => {
    let cku = Uuid.v4();
    let creatorIdentifier;
    if (typeof authState !== "object") {
      throw {
        RE_EXN_ID: CreateGlobalCampaignMutation_CreatorIdentifierNotFound,
        Error: new Error()
      };
    }
    if (authState.TAG === "Logging") {
      throw {
        RE_EXN_ID: CreateGlobalCampaignMutation_CreatorIdentifierNotFound,
        Error: new Error()
      };
    }
    creatorIdentifier = authState._0.user.id;
    let match = makeCreateCampaignsInputs(state, creatorIdentifier);
    let rootCampaignsInputs = match[0];
    if (rootCampaignsInputs.length !== 0) {
      let discountsInput = match[1];
      if (discountsInput.length !== 0) {
        return ApolloHelpers.mergeFutureResults(rootCampaignsInputs.map(param => Future.tapOk(Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, makeVariables(param[0], Scalar.CKU.serialize(cku), param[1], discountsInput, undefined))), undefined, param => param.createPromotionCampaign.cku), param => {
          let match = result.client;
          if (match !== undefined) {
            match.rescript_resetStore();
            return;
          }
        })));
      }
      throw {
        RE_EXN_ID: CreateGlobalCampaignMutation_InvalidInputs,
        Error: new Error()
      };
    }
    throw {
      RE_EXN_ID: CreateGlobalCampaignMutation_InvalidInputs,
      Error: new Error()
    };
  }, []);
}

function makeUpdateCampaignsInputs(state) {
  let match = state.period;
  let match$1;
  if (match !== undefined) {
    match$1 = [
      Scalar.Datetime.serialize(match[0]),
      Scalar.Datetime.serialize(match[1])
    ];
  } else {
    throw {
      RE_EXN_ID: MakeUpdateCampaignsInputs_PeriodNotFound,
      Error: new Error()
    };
  }
  let endDate = match$1[1];
  let startDate = match$1[0];
  let rootCampaignsInputs = Stdlib_Array.filterMap(Belt_Array.reverse(state.rootCampaigns), campaign => {
    if (!campaign.selected) {
      return;
    }
    if (state.name !== "") {
      return [
        campaign.id,
        makeInputObjectInputUpdatePromotionCampaign(state.name, startDate, endDate, undefined, undefined, undefined, undefined)
      ];
    }
    throw {
      RE_EXN_ID: MakeUpdateCampaignsInputs_NameEmpty,
      Error: new Error()
    };
  });
  let discountsInput = Belt_Array.reverse(state.discountedProducts).map(product => {
    let match = PromotionEditDiscountedProduct.isValid(product, state.priceName);
    if (match) {
      return {
        variantCku: Scalar.CKU.serialize(product.cku),
        value: product.discount.amount,
        kind: product.discount.kind
      };
    }
    throw {
      RE_EXN_ID: MakeUpdateCampaignsInputs_InvalidDiscountedProduct,
      Error: new Error()
    };
  });
  return [
    rootCampaignsInputs,
    discountsInput
  ];
}

function useUpdateGlobalCampaign() {
  let mutate = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)[0];
  return React.useCallback((param, state) => {
    let match = makeUpdateCampaignsInputs(state);
    let rootCampaignsInputs = match[0];
    if (rootCampaignsInputs.length !== 0) {
      let discountsInput = match[1];
      if (discountsInput.length !== 0) {
        return ApolloHelpers.mergeFutureResults(rootCampaignsInputs.map(param => Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
          id: param[0],
          input: param[1],
          discountsInput: discountsInput
        })), undefined, param => param.updatePromotionCampaign.cku)));
      }
      throw {
        RE_EXN_ID: UpdateGlobalCampaignMutation_InvalidInputs,
        Error: new Error()
      };
    }
    throw {
      RE_EXN_ID: UpdateGlobalCampaignMutation_InvalidInputs,
      Error: new Error()
    };
  }, []);
}

function useStartGlobalCampaign() {
  let mutate = use$2(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)[0];
  return React.useCallback((param, state) => ApolloHelpers.mergeFutureResults(Stdlib_Array.filterMap(state.rootCampaigns, campaign => {
    if (campaign.selected) {
      return Primitive_option.some(Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        id: campaign.id
      })), undefined, param => param.startPromotionCampaign.cku));
    }
  })), []);
}

function useStartCampaign(id) {
  let mutate = use$2(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)[0];
  return React.useCallback(status => {
    if (status === "NOT_PROGRAMMED") {
      return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        id: id
      })), undefined, param => param.startPromotionCampaign.cku);
    }
    throw {
      RE_EXN_ID: StartCampaignMutation_InvalidStatus,
      Error: new Error()
    };
  }, []);
}

function useStopCampaign(id) {
  let mutate = use$3(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)[0];
  return React.useCallback(status => {
    if (status === "ONGOING" || status === "PROGRAMMED") {
      return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        id: id
      })), undefined, param => param.stopPromotionCampaign.cku);
    }
    throw {
      RE_EXN_ID: StopCampaignMutation_InvalidStatus,
      Error: new Error()
    };
  }, []);
}

export {
  MakeCreateCampaignsInputs_CreatorIdentifierEmpty,
  MakeCreateCampaignsInputs_NameEmpty,
  MakeCreateCampaignsInputs_PeriodNotFound,
  MakeCreateCampaignsInputs_InvalidDiscountedProduct,
  MakeUpdateCampaignsInputs_NameEmpty,
  MakeUpdateCampaignsInputs_PeriodNotFound,
  MakeUpdateCampaignsInputs_InvalidDiscountedProduct,
  CreateGlobalCampaignMutation_InvalidInputs,
  CreateGlobalCampaignMutation_CreatorIdentifierNotFound,
  UpdateGlobalCampaignMutation_InvalidInputs,
  StartCampaignMutation_InvalidStatus,
  StopCampaignMutation_InvalidStatus,
  CreateCampaignMutation,
  UpdateCampaignMutation,
  StartCampaignMutation,
  StopCampaignMutation,
  makeCreateCampaignsInputs,
  useCreateGlobalCampaign,
  makeUpdateCampaignsInputs,
  useUpdateGlobalCampaign,
  useStartGlobalCampaign,
  useStartCampaign,
  useStopCampaign,
}
/* query Not a pure module */
